// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
angular.module('unergie.main')
.controller('createTicketModalCtrl', ($scope, $uibModalInstance, ApiUser, idAccount, ReferencesService, PrmUtilsService, AlertManager, AuthService, ErrorCatcher) => {
    $scope.types = [
        { id: 'question', label: 'Question' },
        { id: 'problem', label: 'Problème' },
        { id: 'incident', label: 'Incident' },
        { id: 'task', label: 'Tâche' },
    ]

    $scope.ticket = {
        idAccount,
        subject: undefined,
        type: $scope.types[0].id,
        body: `\n\nBien à vous,\n${__guard__(__guard__(AuthService.getAuth(), (x1) => x1.user), (x) => x.split(' ')[0])}`,
    }

    $scope.createTicket = function () {
        $scope.creating = true
        return ApiUser.openTicket($scope.ticket).$promise.then(() => {
            AlertManager.success('Ticket ouvert avec succès')
            return $scope.ok() }).catch(ErrorCatcher)
        .finally(() => ($scope.creating = false))
    }

    // RETURN OK
    $scope.ok = () => $uibModalInstance.close()

    return ($scope.close = () => $uibModalInstance.dismiss())
})

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}
